import FollowUps from './FollowUps';

export default FollowUps;
